<script lang="ts">
	//Stores
	import { user_settings } from 'src/stores/account/user';
	import { handleNewsLetterPermissions } from './Notification/user_permissions_helper';

	//Services
	import { format } from '../../../services/i18n';

	//Design system components
	import { Button, Row, Col, Checkbox } from '@Shelly/shelly-design-system';

	let newsletterCheck = $user_settings.newsletter;

	if (newsletterCheck == -1) {
		newsletterCheck = 0;
	}

	let mailValidated = !$user_settings.mail_validated;

	const handleSave = () => {
		handleNewsLetterPermissions(newsletterCheck);
	};
</script>

<!-- <Row>
	<Col xs="12" md="6"> -->
<Checkbox
	size="m"
	class="mb-s"
	bind:checked={newsletterCheck}
	disabled={mailValidated}
	id="checkbox-ag3c98k"
>
	{$format('checkbox_newsletter', {
		default:
			'I want to receive exclusive deals and latest information about Shelly products and Services on my e-mail.',
	})}
</Checkbox>
<!-- </Col>
	<Col xs="12" md="3"> -->
<Button size="m" class="width-md-l width-sm-full" disabled={mailValidated} on:click={handleSave}>
	{$format('button_save')}
</Button>
<!-- </Col>
</Row> -->
